import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.object.assign.js";
function l(e, a) {
  if (!(e instanceof a)) throw new TypeError("Cannot call a class as a function");
}
function o(e, a) {
  for (var t = 0; t < a.length; t++) {
    var n = a[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function u(e, a, t) {
  return a && o(e.prototype, a), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function f(e, a, t) {
  return a in e ? Object.defineProperty(e, a, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[a] = t, e;
}
var m = function m() {},
  c = window.LXAnalytics || m,
  g = /* @__PURE__ */function () {
    function e(a) {
      l(this, e), this.config = a, this.lxCommonParams = a.lxCommonParams, c("config", "defaultCategory", a.defaultCategory), c("config", "defaultCid", a.defaultCid), c("config", "onWebviewAppearAutoPV", !1), c("config", "appName", a.appName), this.tracker = c("getTracker");
    }
    return u(e, [{
      key: "pv",
      value: function value(t, n, i) {
        var s = Object.assign(Object.assign(Object.assign({}, this.lxCommonParams), i), Object.assign({}, n)),
          r = {};
        this.tracker("pageView", {
          custom: Object.assign({}, s)
        }, r, t);
      }
    }, {
      key: "mc",
      value: function value(t, n, i) {
        var s = Object.assign(Object.assign({}, this.lxCommonParams), i),
          r = Object.assign(Object.assign({}, this.lxCommonParams), Object.assign({}, n));
        this.tracker("tag", "fsp_dcep", f({}, i.cid, Object.assign(Object.assign(Object.assign({}, s), r), {
          bid: t
        }))), this.tracker("moduleClick", t, r, s);
      }
    }, {
      key: "mv",
      value: function value(t, n, i) {
        var s = Object.assign(Object.assign({}, this.lxCommonParams), i),
          r = Object.assign(Object.assign({}, this.lxCommonParams), Object.assign({}, n));
        this.tracker("moduleView", t, r, s);
      }
    }, {
      key: "addTag",
      value: function value(t) {
        this.tracker("tag", "pay", t);
      }
    }]), e;
  }();
export { g as default };
